import React from 'react';
import { ImgixParams } from 'react-imgix';
import stringify from 'json-stable-stringify';
import { MediaRefFragment } from '$/GraphQL/schema/types';
import { LocalAsset } from '$/components/ui/Input/PageBuilder.types';
import { useHasChanged } from './useHasChanged';
import { getImgixCropParams } from '$/utils/imgix';

export function useImgixParams(
  asset: LocalAsset,
  value: MediaRefFragment | null | undefined,
  imgProps?: ImgixParams
): ImgixParams {
  const params = { dpr: 2, ...imgProps };
  params.fit = value?.crop ? 'crop' : imgProps?.fit ?? asset.fit;

  const [imgixParams, setImgIxParams] = React.useState(getImgixCropParams(value, params));

  const hasInputChanged = useHasChanged([stringify(value), stringify(params)]);
  React.useEffect(() => {
    if (!hasInputChanged) return;

    setImgIxParams(getImgixCropParams(value, params));
  }, [hasInputChanged, value, params]);

  return imgixParams;
}
